import { render, staticRenderFns } from "./orderProductionOrderItemPopover.vue?vue&type=template&id=73b20ea2&scoped=true&"
import script from "./orderProductionOrderItemPopover.vue?vue&type=script&lang=js&"
export * from "./orderProductionOrderItemPopover.vue?vue&type=script&lang=js&"
import style0 from "./orderProductionOrderItemPopover.vue?vue&type=style&index=0&id=73b20ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b20ea2",
  null
  
)

export default component.exports